import React from 'react';
import { prop } from 'ramda';

import { SvgIcon } from '@interlayer/js/app/components/common/SvgIcon';

import { useDeviceSelector } from '@core/js/store/hooks';
import { clsb } from '@core/js/utils/classNames.util';

import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { TScrollerArrowProps } from '../../types';

import style from '../../Scroller.scss';

const PROPS_ARROW = {
    left: ['arrow-left', 'isLeftArrow', 'Scroller_arrowLeft'],
    right: ['arrow-right', 'isRightArrow', 'Scroller_arrowRight']
};

export const ScrollerArrow: React.FC<TScrollerArrowProps> = ({ isVisible, isLeft, classNames = {}, onClick }) => {
    const isTouchDevice = useDeviceSelector(prop('isTouchDevice'));
    const buildCls = clsb([style, classNames]);
    const [type, classNameModifier, testId] = PROPS_ARROW[isLeft ? 'left' : 'right'];

    if (isTouchDevice) {
        return null;
    }

    return (
        <div
            className={clsx(
                buildCls(['arrowContainer', classNameModifier]),
                { [style.isVisible]: isVisible }
            )}
        >
            <SvgIcon
                type={type}
                data-testid={testId}
                className={buildCls(['arrowIcon'])}
                onClick={() => onClick(Boolean(isLeft))}
            />
        </div>
    );
};
